var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 13.06C12.9227 13.2074 12.7571 13.3256 12.5731 13.4076C12.3891 13.4896 12.1905 13.5336 11.989 13.5372C11.7876 13.5407 11.5876 13.5037 11.4008 13.4283C11.214 13.3528 11.0444 13.2405 10.9019 13.0981C10.7595 12.9557 10.6472 12.786 10.5718 12.5992C10.4963 12.4124 10.4593 12.2124 10.4628 12.011C10.4664 11.8096 10.5105 11.6109 10.5924 11.4269C10.6744 11.2429 10.7926 11.0773 10.94 10.94M14.97 14.97C14.1153 15.6215 13.0746 15.9824 12 16C8.5 16 6.5 12 6.5 12C7.12194 10.841 7.98457 9.82832 9.03 9.03001L14.97 14.97ZM10.95 8.12001C11.2942 8.03945 11.6465 7.99918 12 8.00001C15.5 8.00001 17.5 12 17.5 12C17.1965 12.5678 16.8345 13.1024 16.42 13.595L10.95 8.12001Z",
    stroke: "#0688FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.5L17.5 17.5",
    stroke: "#0688FA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0688FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHide);
export default __webpack_public_path__ + "static/media/icon-hide.22ac983cf5393517b6563292b49e161b.svg";
export { ForwardRef as ReactComponent };